import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  dialogTitle: {
    backgroundColor: '#6D91A2',
    color: '#FFFFFF',
  },
  dialogButton: {
    backgroundColor: '#FF6D00',
    color: '#282828',
    '&:hover': {
      backgroundColor: '#E66200',
    },
  },
}));
